<template>
  <memlist-card>
    <div class="d-flex justify-end">
      <memlist-icon-button
        icon="menu-icon flaticon2-plus"
        :text="$t('PAGES.ATTRIBUTES.NEW_CATEGORY')"
        variant="primary"
        @click="create_group_clicked"
      />
    </div>

    <memlist-static-table
      class="mt-4"
      id="property-groups"
      :fields="headers"
      :items="items"
    >
      <template #cell(action)='row'>
        <div class='d-flex justify-content-end'>
          <memlist-table-button class="mr-2" @click="select_group_clicked(row.item.group_id)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')"/>
          <memlist-table-button @click="delete_group_clicked(row.item.group_id)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')" />
        </div>
      </template>
    </memlist-static-table>
  </memlist-card>
</template>

<script>
import axios from 'axios';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'PropertyGroupTable',
  mixins: [ toasts ],
  props: ['items', 'currentCompanyId'],
  emits: ['create_group_clicked', 'select_group_clicked', 'delete_group_clicked'],
  components: {

  },
  methods: {
    create_group_clicked() {
      this.$emit('create_group_clicked');
    },
    select_group_clicked(group_id) {
      this.$emit('select_group_clicked', group_id);
    },
    delete_group_clicked(group_id) {
      this.$emit('delete_group_clicked', group_id);
    },
    
  },
  data() {
    return {
      headers: [
        {
          key: 'name',
          label: this.$t('PAGES.ATTRIBUTES.CATEGORY'),
          sortable: true,
          thClass: 'pl-7 w-100',
          tdClass: 'pl-7 align-middle'
        },
        {
          key: 'priority',
          label: this.$t('MEMBER_PROPERTY.PRIORITY'),
          sortable: true,
          thClass: 'pl-7',
          tdClass: 'pl-7 align-middle'
        },
        {
          key: 'company.name',
          label: this.$t('COMPANY.COMPANY'),
          sortable: true,
          thClass: 'pl-7 w-100',
          tdClass: 'pl-7 align-middle'
        },
        {
          key: 'action',
          label: '',
          thClass: 'w-110px',
          tdClass: 'align-middle'
        },
      ],
      list: [

      ]
    };
  }
};
</script>
